import styled from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'
import Container from './StyledContainer'

const tabletImageSize = '380px'
const spaceTop = '20px'

const DirectionHero = styled.div`
  overflow: hidden;
  position: relative;
  padding-top: ${spaceTop};
  background-color: var(--color-bg-accent);
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjA0IiBoZWlnaHQ9IjUwMCIgdmlld0JveD0iMCAzMiAxMjA0IDUwMCIgZmlsbD0ibm9uZSI+PGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZGQpIj48cGF0aCBkPSJNMTE3MiA1MzJINTU1LjE0M2MwLTg2Ljk3OS0xMDAuNDM1LTE5My4yMjktMjE3LjQ2Mi0yMjguNjQ2QzIwMC4yNTMgMjYxLjc2MyAzMiAxODguMjUgMzIgMzJoNTU4LjY2OWMxNS4yNDggMTQyLjExNCAxNDUuMDQzIDIwMy4xODEgMjg1LjQ3MyAyMzUuOTM3QzEwMjcuOTcgMzAzLjM1NCAxMTYzLjY4IDM2Ni4zMTIgMTE3MiA1MzJ6IiBmaWxsPSIjRjlGQUZCIi8+PC9nPjxkZWZzPjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZGQiIHg9IjAiIHk9IjAiIHdpZHRoPSIxMjA0IiBoZWlnaHQ9IjU2NCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+PGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+PGZlT2Zmc2V0Lz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxNiIvPjxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4wMiAwIi8+PGZlQmxlbmQgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93Ii8+PGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+PGZlT2Zmc2V0Lz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+PGZlQ29sb3JNYXRyaXggdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjAzIDAiLz48ZmVCbGVuZCBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJlZmZlY3QyX2Ryb3BTaGFkb3ciLz48ZmVCbGVuZCBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QyX2Ryb3BTaGFkb3ciIHJlc3VsdD0ic2hhcGUiLz48L2ZpbHRlcj48L2RlZnM+PC9zdmc+');
  background-size: auto 100%;
  background-position: calc(50% + 70px) 0;
  background-repeat: no-repeat;

  ${maxWidth(vars.breakpoints.tablet - 1)`
    padding-top: calc(${tabletImageSize} + ${spaceTop});
    background: var(--color-bg-accent);
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    padding-top: calc(3 / 5 * 100% + ${spaceTop});
  `}
`

DirectionHero.Container = styled(Container)`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);
  grid-gap: 32px;

  ${maxWidth(vars.breakpoints.tablet - 1)`
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 0;
  `}
`

DirectionHero.Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 0 60px;

  ${maxWidth(vars.breakpoints.tablet - 1)`
    padding: 16px 0 40px;
  `}
`

DirectionHero.Title = styled.h1`
  font-weight: 300;
  font-size: 40px;
  line-height: 1.2;
  letter-spacing: -0.01em;

  ${maxWidth(vars.breakpoints.tablet)`
    font-size: 36px;
  `}

  ${maxWidth(vars.breakpoints.mTablet)`
    font-size: 32px;
  `}
`

DirectionHero.Desc = styled.p`
  margin-top: 20px;
  font-size: 16px;
  line-height: 1.6;
  color: var(--color-secondary);
`

DirectionHero.Button = styled.div`
  --button-width: 260px;
  margin-top: 36px;

  ${maxWidth(vars.breakpoints.mTablet)`
    --button-width: 100%;
    --button-padding-top: 17px;
    --button-padding-bottom: 17px;
    margin-top: 30px;
  `}
`

DirectionHero.Image = styled.div`
  position: relative;
  width: calc(100% + ${vars.container.spaceDesktop}px / 2);
  margin-top: auto;

  &::after {
    position: relative;
    z-index: 1;
    content: '';
    display: block;
    width: 100%;
    padding-top: calc(3 / 5 * 100%);
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: bottom right;
  }

  ${maxWidth(vars.breakpoints.sDesktop)`
    width: calc(100% + ${vars.container.spaceXsDesktop}px / 2);
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    width: 100%;
  `}

  ${maxWidth(vars.breakpoints.tablet - 1)`
    order: -1;
    position: absolute;
    top: 0;
    left: 0;
    padding-top: ${spaceTop};
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjA0IiBoZWlnaHQ9IjUwMCIgdmlld0JveD0iMCAzMiAxMjA0IDUwMCIgZmlsbD0ibm9uZSI+PGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZGQpIj48cGF0aCBkPSJNMTE3MiA1MzJINTU1LjE0M2MwLTg2Ljk3OS0xMDAuNDM1LTE5My4yMjktMjE3LjQ2Mi0yMjguNjQ2QzIwMC4yNTMgMjYxLjc2MyAzMiAxODguMjUgMzIgMzJoNTU4LjY2OWMxNS4yNDggMTQyLjExNCAxNDUuMDQzIDIwMy4xODEgMjg1LjQ3MyAyMzUuOTM3QzEwMjcuOTcgMzAzLjM1NCAxMTYzLjY4IDM2Ni4zMTIgMTE3MiA1MzJ6IiBmaWxsPSIjRjlGQUZCIi8+PC9nPjxkZWZzPjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZGQiIHg9IjAiIHk9IjAiIHdpZHRoPSIxMjA0IiBoZWlnaHQ9IjU2NCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+PGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+PGZlT2Zmc2V0Lz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxNiIvPjxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4wMiAwIi8+PGZlQmxlbmQgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93Ii8+PGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+PGZlT2Zmc2V0Lz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+PGZlQ29sb3JNYXRyaXggdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjAzIDAiLz48ZmVCbGVuZCBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJlZmZlY3QyX2Ryb3BTaGFkb3ciLz48ZmVCbGVuZCBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QyX2Ryb3BTaGFkb3ciIHJlc3VsdD0ic2hhcGUiLz48L2ZpbHRlcj48L2RlZnM+PC9zdmc+');
    background-size: auto 100%;
    background-position: top center;
    background-repeat: no-repeat;

    &::after {
      padding-top: ${tabletImageSize};
      background: linear-gradient(0deg, var(--color-bg-accent) 0%, rgba(var(--color-bg-accent-rgb), 0) 100%);
      background-size: 100% 80px;
      background-repeat: no-repeat;
      background-position: bottom left;
    }

    img {
      top: ${spaceTop};
      height: calc(100% - ${spaceTop});
      object-position: bottom center;
    }
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    &::after {
      padding-top: calc(3 / 5 * 100%);
    }
  `}
`

export default DirectionHero
